import React from 'react';

/**
 * Container Component
 * Обёртка для контента с ограничением ширины и центрированием
 * 
 * @param {string} maxWidth - Максимальная ширина ('sm', 'md', 'lg', 'xl')
 * @param {string} className - Дополнительные классы
 * @param {ReactNode} children - Содержимое
 */
export const Container = ({ 
  maxWidth = 'xl', 
  className = '', 
  children 
}) => {
  const widths = {
    sm: 'max-w-[640px]',
    md: 'max-w-[768px]',
    lg: 'max-w-[1024px]',
    xl: 'max-w-[1440px]',
    full: 'max-w-full'
  };

  return (
    <div className={`mx-auto px-4 ${widths[maxWidth]} ${className}`}>
      {children}
    </div>
  );
};

export default Container;